import { render, staticRenderFns } from "./AddNewCaseModal.vue?vue&type=template&id=fe60dca4"
import script from "./AddNewCaseModal.vue?vue&type=script&lang=js"
export * from "./AddNewCaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports